export default __webpack_public_path__ + "static/TimisoaraTech_logo@2x-8e4c6cc526b7cfd7fa278ea5b0d91172.png";